import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old collection pages. The catalog now lives on / with its filters in
 * the query string, so the slugs that used to mean a mail type land there.
 */
export const Route = createFileRoute("/app/collections/$slug")({
  beforeLoad: ({ params }) => {
    const mail =
      params.slug === "addressed-mail"
        ? "addressed"
        : params.slug === "unaddressed-mail"
          ? "unaddressed"
          : undefined;
    throw redirect({ to: "/", search: mail ? { mail } : {} });
  },
  component: () => null,
});
